<template>
  <!--  第一个详情页面-->
  <div class="home_layout">
    <div class="tab-list">
      <div class="tab-btn" :class="{ 'tab-active': tabActive === 0 }" @click="handleFilterData(0)">全部</div>
      <div class="tab-btn" :class="{ 'tab-active': tabActive === 1 }" @click="handleFilterData(1)">已过期</div>
    </div>
    <div class="home_body">
      <div class="data-list" v-if="filterDataList.length > 0">
        <div v-for="item in filterDataList" :key="item.id" class="coupon-item">
          <time class="coupon-time">{{ item.createTime }}</time>
          <div class="coupon-content" @click="detailClick(item)">
            <div class="left">
              <img class="pic" :src="getImageUrl(item.picUrl)"/>
              <div class="coupon-info">
                <div>
                  <div class="coupon-title">{{ item.title }}</div>
                  <div class="coupon-count">X{{ item.count }}张</div>
                </div>
                <div class="coupon-validate">{{ item.validDate }}</div>
              </div>
            </div>
            <div class="right">
              <div class="coupon-amount">
                <div class="amount">
                  <span>{{ item.amounts }}</span>
                  元
                </div>
              </div>
              <div
                  class="btn"
                  :class="{
                  'expired-btn': !item.enabledStatus || item.disabled ||
                                (['4', '5', '6'].indexOf(item.useStatus) !== -1 && !item.isClickable)
                }"
                  @click.stop="handleBtnClick(item)"
              >
                {{ setBtnStatus(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="home_body_middle_nodata">
        <img
            src="../../../static/images/vip_discounts/nodata.png"
            alt=""
            width="100%"
            class="home_body_middle_nodata_img"/>
        <p class="home_body_middle_nodata_title">暂无优惠券</p>
        <p class="home_body_middle_nodata_content">您还没有领取优惠券喔～</p>
      </div>
    </div>

    <!-- 充值确认弹窗 -->
    <div v-if="showRechargeConfirm" class="recharge-modal">
      <div class="recharge-modal-mask"></div>
      <div class="recharge-modal-content">
        <div class="recharge-modal-header">
          <h3>充值确认</h3>
          <span class="recharge-modal-close" @click="closeRechargeConfirm">×</span>
        </div>
        <div class="recharge-modal-body">
          <p class="recharge-confirm-text">
            您确定要充值 <span class="recharge-amount">{{ currentRechargeItem && currentRechargeItem.amounts }}</span>
            元吗？
          </p>
          <div class="recharge-info" v-if="currentRechargeItem">
            <p><span>商品名称：</span>{{ currentRechargeItem.title }}</p>
            <p><span>充值金额：</span>{{ currentRechargeItem.amounts }}元</p>
            <p><span>到账账户：</span><span class="recharge-account">{{ rechargeAccountText }}</span></p>
          </div>
        </div>
        <div class="recharge-modal-footer">
          <button class="recharge-btn-cancel" @click="closeRechargeConfirm">取消</button>
          <button class="recharge-btn-confirm" @click="confirmRecharge">确认充值</button>
        </div>
      </div>
    </div>

    <!-- 充值结果弹窗 -->
    <div v-if="showRechargeResult" class="recharge-modal">
      <div class="recharge-modal-mask"></div>
      <div class="recharge-modal-content">
        <div class="recharge-modal-header">
          <h3>{{ rechargeResult.title }}</h3>
        </div>
        <div class="recharge-modal-body result-body">
          <div class="result-icon" :class="rechargeResult.iconClass">
            <i :class="rechargeResult.icon"></i>
          </div>
          <p class="result-message">{{ rechargeResult.message }}</p>
        </div>
        <div class="recharge-modal-footer">
          <button class="recharge-btn-confirm" @click="closeRechargeResult">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  data() {
    return {
      detailinfo: {},
      dataList: [],
      tabActive: 0,
      couponInfo: {},
      showRechargeConfirm: false,
      showRechargeResult: false,
      currentRechargeItem: null,
      // 商品维护的绑定账号（用于充值弹窗展示到账账户）
      bindAccount: '',
      accountLoading: false,
      rechargeResult: {
        success: false,
        title: '',
        message: '',
        icon: '',
        iconClass: ''
      }
    }
  },
  mounted() {
    console.log('88', this.$route.params.goodsType)
    console.log('91', this.$route.params.regionNo)
    const couponId = this.$route.params.couponId
    const memberId = this.$route.params.memberId || this.loginInfo.id
    const goodsId = this.$route.params.goodsId
    this.couponInfo = {
      couponId,
      memberId,
      goodsId
    }
    this.getRecords()
  },
  computed: {
    ...mapState(['loginInfo']),
    contents() {
      return this.detailinfo.useMethod
    },
    // 是否山东区域（regionNo = 37）
    isShandongRegion() {
      const regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo')
      return String(regionNo) === '37'
    },
    // 当前充值商品名称
    rechargeGoodsName() {
      return (this.currentRechargeItem && (this.currentRechargeItem.title || this.currentRechargeItem.goodsName)) || ''
    },
    // 到账账户是否使用维护的绑定账号：
    // 非山东区域全部使用；山东区域仅天猫/淘宝类券使用，其他商品使用登录手机号
    isUseBindAccount() {
      if (!this.isShandongRegion) return true
      const goodsName = this.rechargeGoodsName
      return goodsName.includes('天猫') || goodsName.includes('淘宝')
    },
    // 充值到账账户
    rechargeAccountText() {
      if (!this.isUseBindAccount) {
        return this.loginInfo.mobile || this.loginInfo.phone || this.loginInfo.account || '--'
      }
      if (this.accountLoading) return '查询中...'
      return this.bindAccount || '未绑定账号'
    },
    filterDataList() {
      return this.tabActive === 0
          ? this.dataList
          : this.dataList.filter((item) => {
            return item.expiredStatus === '1'
          })
    }
  },
  filters: {},
  methods: {
    /** 获取列表 */
    getRecords() {
      let displayMode = localStorage.getItem('displayMode')

      let apiEndpoint = this.apis.findOrderList
      if (displayMode === '1') {
        apiEndpoint = this.apis.findOrderListSingle
      }

      this.post(apiEndpoint, {
        memberId: this.loginInfo.id
      })
          .then((res) => {
            if (res.data.code === '0') {
              let data = res.data.data
              console.log('data', data)

              data = data.map((item) => {
                const dateStr = `${item.createTime.substring(0, 4)}年${item.createTime.substring(
                    5,
                    7
                )}月${item.createTime.substring(8, 10)}日`
                const time = item.createTime ? dateStr : '--'

                let useStatus = item.useStatus.toString()
                let isClickable = true
                let disabled = false
                // 修复：这里也替换hasOwnProperty写法
                let enabledStatus = Object.prototype.hasOwnProperty.call(item, 'enabledStatus')
                    ? item.enabledStatus
                    : true

                if (displayMode === '1') {
                  const isRechargeItem = this.isRechargeGoods(item.goodsName || item.title)
                  useStatus = item.useStatus || (isRechargeItem ? '3' : '0')
                  useStatus = useStatus.toString()
                  isClickable = !['4', '5', '6'].includes(useStatus)
                  disabled = false
                }

                return {
                  ...item,
                  id: item.goodsId,
                  amounts: item.goodsPrice,
                  count: item.num,
                  title: item.goodsName,
                  content: '每月特权 会员专享',
                  orderId: item.orderId,
                  validDate: item.validDate ? '有效期至' + item.validDate : '长期有效',
                  createTime: time,
                  picUrl: item.picUrl,
                  useStatus: useStatus,
                  isClickable: isClickable,
                  disabled: disabled,
                  enabledStatus: enabledStatus
                }
              })
              this.dataList = data
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },

    /** 判断是否是充值商品 */
    isRechargeGoods(goodsName) {
      if (!goodsName) return false
      const rechargeKeywords = ['充值', '屈臣氏E-FUN卡', '天猫超市电子券', '京东超市京东E卡','唯品会唯品卡','沃尔玛电子券']
      console.log('判断商品是否是充值商品：', goodsName)
      return rechargeKeywords.some(keyword => goodsName.includes(keyword))
    },

    getImageUrl(filename) {
      if (!filename || filename === 'null' || filename === 'undefined') {
        return require('@/static/images/vip_discounts/banner/jdtm_A.png');
      }
      return require(`@/static/images/vip_discounts/${filename}`);
    },

    /** 查看详情 */
    detailClick(item) {
      console.log('99', item)
      console.log(this.loginInfo.id)
      console.log('$route', this.$route.params.regionNo)

      if (['3', '4', '5', '6'].includes(item.useStatus)) {
        console.log('充值状态，不跳转详情页')
        return
      }

      let displayMode = localStorage.getItem('displayMode')
      console.log('打开模式' + displayMode)
      console.log(item)
      if (displayMode === '1') {
        if (item.expiredStatus === '1') {
          return
        } else if (item.expiredStatus === '0' && item.title == '中萃到家电子券') {
          return;
        } else if (item.expiredStatus === '0' && item.title != '中萃到家电子券') {
          this.$router.push({
            name: 'couponDetail',
            params: {
              goodsName: item.goodsName,
              regionNo: item.regionNo,
              orderId: item.orderId,
              orderDetailId: item.orderDetailId,
              couponId: '',
              memberId: item.memberId,
              seeFlag: item.useStatus != '0' ? '2' : '1',
              goodsId: item.goodsId,
              cardgoodsId: item.id,
            }
          })
        }
      }

      if (displayMode === '2') {
        let regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo');
        if (regionNo ==='37'){
          if (item.expiredStatus === '1') {
            return
          } else if (item.expiredStatus === '0') {
            this.$router.push({
              name: 'receiveDiscount',
              params: {
                orderId: item.orderId,
                memberId: this.loginInfo.id,
                couponId: item.id,
                goodsId: item.id,
                regionNo: this.$route.params.regionNo
              }
            })
            console.log('111', item.orderId)
            if (item.orderId != null && item.orderId !== '') {
              localStorage.setItem('orderId', item.orderId)
            }
          }
        }else{
          if (item.expiredStatus === '1') {
            return
          } else if (item.expiredStatus === '0' && item.title == '中萃到家电子券') {
            console.log('zl2')
            return
          } else if (item.expiredStatus === '0' && item.title != '中萃到家电子券') {
            this.$router.push({
              name: 'receiveDiscount',
              params: {
                orderId: item.orderId,
                memberId: this.loginInfo.id,
                couponId: item.id,
                goodsId: item.id,
                regionNo: this.$route.params.regionNo
              }
            })
            console.log('111', item.orderId)
            if (item.orderId != null && item.orderId !== '') {
              localStorage.setItem('orderId', item.orderId)
            }
          }
        }
      }
    },

    /** 按钮文案 */
    setBtnStatus(item) {
      console.log('444', item)
      let regionNo = localStorage.getItem('regionNo');
      console.log('当前区域编号' + regionNo)
      console.log('555', item.expiredStatus)
      let displayMode = localStorage.getItem('displayMode');
      console.log('当前模式' + displayMode)

      if (item.orderId != null && item.orderId !== '') {
        localStorage.setItem('orderId', item.orderId)
      }

      // ===== 核心修复：替换item.hasOwnProperty为Object.prototype.hasOwnProperty.call =====
      if (Object.prototype.hasOwnProperty.call(item, 'enabledStatus') && !item.enabledStatus) {
        return '未生效'
      }

      if (displayMode === '1' && item.useStatus) {
        if (item.title !== '中萃到家电子券'){
          const statusMap = {
            '0': '立即使用',
            '1': '查看',
            '2': '下月使用',
            '3': '充值',
            '4': '充值成功',
            '5': '充值失败',
            '6': '充值中'
          }
          const statusText = statusMap[item.useStatus]
          if (statusText) {
            return statusText
          }

        }

      }

      if (displayMode === '1') {
        if (item.title == '中萃到家电子券') {
          switch (item.expiredStatus) {
            case '0':
              return '已激活'
            case '1':
              return '已过期'
            default:
              return '--'
          }
        }
        if (item.expiredStatus === '1') {
          return '已过期'
        }
        if (item.expiredStatus === '0') {
          if (item.useStatus === '0') {
            return '立即使用'
          } else {
            return '查看'
          }
        }
      }

      if (displayMode === '2') {
        if (regionNo === '37') {
          switch (item.expiredStatus) {
            case '0':
              return ' 查看'
            case '1':
              return '已过期'
            default:
              return '--'
          }
        } else {
          if (item.title == '中萃到家电子券') {
            switch (item.expiredStatus) {
              case '0':
                return '已激活'
              case '1':
                return '已过期'
              default:
                return '--'
            }
          } else {
            if (item.title === '中萃到家电子券'){
              if (item.useStatus === '0') {
                return '立即使用'
              } else {
                return '查看'
              }
            } else {
              switch (item.expiredStatus) {
                case '0':
                  return ' 查看'
                case '1':
                  return '已过期'
                default:
                  return '--'
              }
            }
          }
        }
      }
    },

    /** 按钮点击处理 */
    handleBtnClick(item) {
      console.log('按钮点击，状态:', item.useStatus, '生效状态:', item.enabledStatus)

      if (!item.enabledStatus) {
        return
      }

      if (['4', '5', '6'].includes(item.useStatus)) {
        return
      }

      switch (item.useStatus) {
        case '0':
        case '1':
          this.detailClick(item)
          break
        case '3':
          this.handleRechargeClick(item)
          break
        default:
          this.detailClick(item)
      }
    },

    /** 处理充值点击 */
    handleRechargeClick(item) {
      console.log('开始充值:', item)
      this.currentRechargeItem = item
      this.showRechargeConfirm = true
      // 到账账户为维护的绑定账号时（非山东区域全部、山东区域的天猫超市电子券），需要先查询回显
      if (this.isUseBindAccount) {
        this.queryBindAccount(this.getBindGoodsName(item))
      }
    },

    /** 获取用于查询绑定账号的商品名称（天猫/淘宝类券统一按天猫超市电子券查询） */
    getBindGoodsName(item) {
      const goodsName = (item && (item.title || item.goodsName)) || ''
      // 与详情页维护账号时使用的商品名保持一致，避免名称后缀不同导致查不到账号
      if (goodsName.includes('天猫') || goodsName.includes('淘宝')) return '天猫超市电子券'
      return goodsName
    },

    /** 查询维护的绑定账号（用于展示到账账户） */
    queryBindAccount(goodsName) {
      if (!this.loginInfo.id) {
        console.warn('用户未登录，无法查询绑定账号')
        return
      }
      this.accountLoading = true
      this.bindAccount = ''
      const params = {
        memberId: this.loginInfo.id,
        goodsName: goodsName
      }
      console.log('查询绑定账号参数：', params)
      this.post(this.apis.queryAccount, params)
          .then((res) => {
            this.accountLoading = false
            if (res.data.code === '0') {
              this.bindAccount = (res.data.data && res.data.data.account) || ''
              console.log('查询绑定账号成功（到账账户）：', this.bindAccount, goodsName)
            } else {
              console.log('查询绑定账号失败：', res.data.message)
            }
          })
          .catch((error) => {
            this.accountLoading = false
            console.log('查询绑定账号异常：', error)
          })
    },

    /** 确认充值 */
    async confirmRecharge() {
      const rechargeItem = this.currentRechargeItem
      if (!rechargeItem) {
        this.closeRechargeConfirm()
        return
      }

      try {
        this.closeRechargeConfirm()

        const itemIndex = this.dataList.findIndex(item =>
            item.id === rechargeItem.id && item.orderId === rechargeItem.orderId
        )

        if (itemIndex !== -1) {
          this.$set(this.dataList[itemIndex], 'useStatus', '6')
          this.$set(this.dataList[itemIndex], 'isClickable', false)
          this.$set(this.dataList[itemIndex], 'disabled', true)
        }

        const regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo')

        console.log('充值参数:', {
          goodsName: rechargeItem.title,
          regionNo: regionNo,
          orderId: rechargeItem.orderId,
          orderDetailId: rechargeItem.orderDetailId || rechargeItem.id,
          couponId: this.couponInfo.couponId,
          memberId: this.couponInfo.memberId,
          goodsId: rechargeItem.goodsId || rechargeItem.id
        })

        const response = await this.post(this.apis.recharge, {
          goodsName: rechargeItem.title,
          regionNo: regionNo,
          orderId: rechargeItem.orderId,
          orderDetailId: rechargeItem.orderDetailId || rechargeItem.id,
          couponId: this.couponInfo.couponId,
          memberId: this.couponInfo.memberId,
          goodsId: rechargeItem.goodsId || rechargeItem.id,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        console.log('充值响应:', response)

        if (response.data.code === "200") {
          if (itemIndex !== -1) {
            this.$set(this.dataList[itemIndex], 'useStatus', '6')
          }

          this.showRechargeResult = true
          this.rechargeResult = {
            success: true,
            title: '充值提交成功',
            message: `充值${rechargeItem.amounts}元订单已经提交成功，请注意查收！`,
            icon: 'el-icon-success',
            iconClass: 'success'
          }

          setTimeout(() => {
            this.getRecords()
          }, 2000)

        } else {
          if (itemIndex !== -1) {
            this.$set(this.dataList[itemIndex], 'useStatus', '5')
          }

          this.showRechargeResult = true
          this.rechargeResult = {
            success: false,
            title: '充值失败',
            message: response.data.message || '充值失败，请重试',
            icon: 'el-icon-error',
            iconClass: 'error'
          }
        }

      } catch (error) {
        console.error('充值失败:', error)

        const itemIndex = this.dataList.findIndex(item =>
            item.id === rechargeItem.id && item.orderId === rechargeItem.orderId
        )

        if (itemIndex !== -1) {
          this.$set(this.dataList[itemIndex], 'useStatus', '3')
          this.$set(this.dataList[itemIndex], 'isClickable', true)
          this.$set(this.dataList[itemIndex], 'disabled', false)
        }

        this.showRechargeResult = true
        this.rechargeResult = {
          success: false,
          title: '充值失败',
          message: '网络错误，请稍后重试',
          icon: 'el-icon-error',
          iconClass: 'error'
        }
      }
    },

    /** 关闭充值确认弹窗 */
    closeRechargeConfirm() {
      this.showRechargeConfirm = false
    },

    /** 关闭充值结果弹窗 */
    closeRechargeResult() {
      this.showRechargeResult = false
      this.rechargeResult = {
        success: false,
        title: '',
        message: '',
        icon: '',
        iconClass: ''
      }
      this.currentRechargeItem = null
    },

    handleFilterData(index) {
      this.tabActive = index
    }
  }
}
</script>

<style scoped lang="less">
.home_layout {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.tab-list {
  background: #fff;
  padding: 26px 32px;
  display: flex;
  align-items: center;

  .tab-btn {
    height: 48px;
    line-height: 48px;
    background: #eeeeee;
    border-radius: 8px;
    padding: 0 28px;
    margin-right: 16px;
    color: rgba(0, 0, 0, 0.6);
  }

  .tab-active {
    color: #000;
  }
}

.home_body {
  height: 100%;
  padding: 0 24px;

  .coupon-item {
    .coupon-time {
      font-size: 28px;
      color: #919191;
      margin-top: 24px;
      margin-bottom: 16px;
      text-align: center;
      display: block;
    }

    .coupon-content {
      background: #fff;
      border-radius: 16px;
      display: flex;

      .left {
        display: flex;
        flex: 1;
        padding-right: 28px;
        border-right: 1px dashed #d3d3d3;
        padding: 20px 20px 20px 28px;

        .coupon-info {
          margin-left: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .coupon-title {
            font-size: 26px;
            color: #3f2a20;
            line-height: 38px;
            font-weight: bold;
          }

          .coupon-count {
            font-size: 22px;
            color: #dd5701;
            line-height: 33px;
            margin-top: 10px;
          }

          .coupon-validate {
            font-size: 20px;
            color: #919191;
            line-height: 28px;
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 20px 28px 20px 28px;

        .coupon-amount {
          color: #dd5701;
          font-size: 30px;
          display: flex;
          align-items: center;
          flex: 1;

          .amount {
            display: flex;
            align-items: end;
          }

          span {
            font-size: 60px;
            margin-right: 6px;
            font-weight: bold;
            line-height: 1;
          }
        }

        .btn {
          width: 170px;
          height: 56px;
          line-height: 56px;
          border-radius: 32px;
          background: #fb7019;
          color: #fff;
          font-size: 28px;
          text-align: center;
          cursor: pointer;
        }

        .expired-btn {
          background: rgba(251, 112, 25, 0.1);
          color: #dd5701;
          cursor: not-allowed;
        }
      }

      .pic {
        width: 176px;
        height: 176px;
        border-radius: 16px;
        display: block;
      }
    }
  }

  &_middle {
    &_nodata {
      display: grid;
      justify-content: center;
      align-items: center;
      padding-top: 30%;

      &_img {
        max-width: 200px;
        margin: 0 auto;
      }

      &_title {
        color: #3f3f3f;
        font-size: 30px;
        text-align: center;
        margin-top: 24px;
        font-weight: 400;
      }

      &_content {
        color: #848484;
        font-size: 20px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}

.recharge-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .recharge-modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .recharge-modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 500px;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);

    .recharge-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      border-bottom: 1px solid #eee;

      h3 {
        margin: 0;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }

      .recharge-modal-close {
        font-size: 24px;
        color: #999;
        cursor: pointer;
        line-height: 1;

        &:hover {
          color: #666;
        }
      }
    }

    .recharge-modal-body {
      padding: 24px;

      .recharge-confirm-text {
        font-size: 16px;
        color: #333;
        text-align: center;
        margin-bottom: 20px;

        .recharge-amount {
          color: #fb7019;
          font-weight: bold;
          font-size: 18px;
        }
      }

      .recharge-info {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 20px;

        p {
          margin: 8px 0;
          font-size: 14px;
          color: #666;

          span {
            color: #333;
            font-weight: 500;
          }

          .recharge-account {
            color: #cd0c09;
            font-weight: bold;
          }
        }
      }

      &.result-body {
        text-align: center;

        .result-icon {
          width: 60px;
          height: 60px;
          line-height: 60px;
          border-radius: 50%;
          margin: 0 auto 15px;
          font-size: 30px;

          &.success {
            background: #e8f5e9;
            color: #4caf50;
          }

          &.error {
            background: #ffebee;
            color: #f44336;
          }
        }

        .result-message {
          font-size: 16px;
          color: #666;
          margin-bottom: 10px;
        }
      }
    }

    .recharge-modal-footer {
      display: flex;
      padding: 0 24px 24px;

      button {
        flex: 1;
        height: 44px;
        border: none;
        border-radius: 22px;
        font-size: 16px;
        cursor: pointer;
        margin: 0 5px;

        &:focus {
          outline: none;
        }
      }

      .recharge-btn-cancel {
        background: #f0f0f0;
        color: #666;

        &:hover {
          background: #e0e0e0;
        }
      }

      .recharge-btn-confirm {
        background: #fb7019;
        color: #fff;

        &:hover {
          background: #e86416;
        }
      }
    }
  }
}
</style>